import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }
  const personal =
    '({q48.0} = 0 or {q48.0} = 1 or {q48.0} = 2 or {q48.0} = 3 or {q48.0} = 4) or ({q48.1} = 0 or {q48.1} = 1 or {q48.1} = 2 or {q48.1} = 3 or {q48.1} = 4) or ({q48.2} = 0 or {q48.2} = 1 or {q48.2} = 2 or {q48.2} = 3 or {q48.2} = 4) or ({q48.3} = 0 or {q48.3} = 1 or {q48.3} = 2 or {q48.3} = 3 or {q48.3} = 4) or ({q48.4} = 0 or {q48.4} = 1 or {q48.4} = 2 or {q48.4} = 3 or {q48.4} = 4) or ({q48.5} = 0 or {q48.5} = 1 or {q48.5} = 2 or {q48.5} = 3 or {q48.5} = 4)'
  const J1adiffcult =
    '{q70.0} = 1 or {q70.0} = 2 or {q70.0} = 3 or {q70.1} = 1 or {q70.1} = 2 or {q70.1} = 3 or {q70.2} = 1 or {q70.2} = 2 or {q70.2} = 3 or {q70.3} = 1 or {q70.3} = 2 or {q70.3} = 3 or {q70.4} = 1 or {q70.4} = 2 or {q70.4} = 3 or {q70.5} = 1 or {q70.5} = 2 or {q70.5} = 3 or {q70.6} = 1 or {q70.6} = 2 or {q70.6} = 3 or {q70.7} = 1 or {q70.7} = 2 or {q70.7} = 3 or {q70.8} = 1 or {q70.8} = 2 or {q70.8} = 3'
  const J1bdiffcult =
    '{q106.0} = 1 or {q106.0} = 2 or {q106.0} = 3 or {q106.1} = 1 or {q106.1} = 2 or {q106.1} = 3 or {q106.2} = 1 or {q106.2} = 2 or {q106.2} = 3 or {q106.3} = 1 or {q106.3} = 2 or {q106.3} = 3 or {q106.4} = 1 or {q106.4} = 2 or {q106.4} = 3 or {q106.5} = 1 or {q106.5} = 2 or {q106.5} = 3 or {q106.6} = 1 or {q106.6} = 2 or {q106.6} = 3 or {q106.7} = 1 or {q106.7} = 2 or {q106.7} = 3'
  const J1cdiffcult =
    '{q139.0} = 1 or {q139.0} = 2 or {q139.0} = 3 or {q139.1} = 1 or {q139.1} = 2 or {q139.1} = 3 or {q139.2} = 1 or {q139.2} = 2 or {q139.2} = 3 or {q139.3} = 1 or {q139.3} = 2 or {q139.3} = 3 or {q139.4} = 1 or {q139.4} = 2 or {q139.4} = 3 or {q139.5} = 1 or {q139.5} = 2 or {q139.5} = 3 or {q139.6} = 1 or {q139.6} = 2'

  const visibleIfConditionsInit = {
    q6: '{q5} = 0',
    q7: '{q5} = 1 or {q5} = 2',
    q8: '{q5} = 1 or {q5} = 2 or {q5} = 3 or {q5} = 4 or {q5} = 5',

    q15: '{q14} = "other"',

    q17: '{q16} = "other"',
    q18: '{q16} = "other"',
    q19: '{q16} = "other"',
    q20: '{q16} = "other"',
    q21: '{q16} = "other"',

    q23: '({q16} = "other") and ({q22} = 0 or {q22} = 1)',

    // 特殊矩陣
    q33: '{q32.0} = 1 or {q32.1} = 1 or {q32.2} = 1 or {q32.3} = 1 or {q32.4} = 1 or {q32.5} = 1 or {q32.6} = 1',
    'q33.row0': '{q32.0} = 1',
    'q33.row1': '{q32.1} = 1',
    'q33.row2': '{q32.2} = 1',
    'q33.row3': '{q32.3} = 1',
    'q33.row4': '{q32.4} = 1',
    'q33.row5': '{q32.5} = 1',
    'q33.row6': '{q32.6} = 1',
    q34: '{q33.0} = 1 or {q33.1} = 1 or {q33.2} = 1 or {q33.3} = 1 or {q33.4} = 1 or {q33.5} = 1 or {q33.6} = 1',
    'q34.row0': '{q33.0} = 1',
    'q34.row1': '{q33.1} = 1',
    'q34.row2': '{q33.2} = 1',
    'q34.row3': '{q33.3} = 1',
    'q34.row4': '{q33.4} = 1',
    'q34.row5': '{q33.5} = 1',
    'q34.row6': '{q33.6} = 1',
    q35: '{q33.0} = 0',
    q36: '{q33.1} = 0',
    q37: '{q33.2} = 0',
    q38: '{q33.3} = 0',
    q39: '{q33.4} = 0',
    q40: '{q33.5} = 0',
    q41: '{q33.6} = 0',

    q43: '{q42.0} = 0',
    q44: '{q42.1} = 0',
    q45: '{q42.2} = 0',
    q46: '{q42.3} = 0',

    q47: '{q42.0} = 1 or {q42.1} = 1 or {q42.2} = 1 or {q42.3} = 1',
    'q47.row0': '{q42.0} = 1',
    'q47.row1': '{q42.1} = 1',
    'q47.row2': '{q42.2} = 1',
    'q47.row3': '{q42.3} = 1',

    q49: personal,
    q50: '{q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4',
    q51: '({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4) and ({q50} = 0 or {q50} = 1 or {q50} = 2 or {q50} = 3 or {q50} = 4)',
    q52: '({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4) and ({q50} = 0 or {q50} = 1 or {q50} = 2 or {q50} = 3 or {q50} = 4)',
    q53: '({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4) and ({q50} = 0 or {q50} = 1 or {q50} = 2 or {q50} = 3 or {q50} = 4)',
    q54: '({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4) and ({q50} = 0 or {q50} = 1 or {q50} = 2 or {q50} = 3 or {q50} = 4)',
    q55: '({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4) and ({q50} = 0 or {q50} = 1 or {q50} = 2 or {q50} = 3 or {q50} = 4)',
    q56: '({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4) and ({q50} = 0 or {q50} = 1 or {q50} = 2 or {q50} = 3 or {q50} = 4)',
    q57: '({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4) and ({q50} = 0 or {q50} = 1 or {q50} = 2 or {q50} = 3 or {q50} = 4)',

    q59: '{q58} anyof [0, 1, 2, "other"]',
    q60: '{q58} anyof [0, 1, 2, "other"]',
    q61: '{q58} anyof [0, 1, 2, "other"]',
    q62: '{q58} anyof [0, 1, 2, "other"]',
    q63: '{q58} anyof [0, 1, 2, "other"]',

    // ++++++這邊可能會加一題++++++
    q64: '({q58} anyof [0, 1, 2, "other"]) and ({q62.0} = 0 or {q62.0} = 1)',
    q65: '({q58} anyof [0, 1, 2, "other"]) and ({q62.1} = 0 or {q62.1} = 1)',
    q66: '({q58} anyof [0, 1, 2, "other"]) and ({q62.2} = 0 or {q62.2} = 1)',
    q67: '({q58} anyof [0, 1, 2, "other"]) and ({q62.3} = 0 or {q62.3} = 1)',
    q68: '({q58} anyof [0, 1, 2, "other"]) and ({q62.4} = 0 or {q62.4} = 1)',
    q69: '({q58} anyof [0, 1, 2, "other"]) and ({q62.5} = 0 or {q62.5} = 1)',

    // J1a
    q71: J1adiffcult,
    'q71.row0': '{q70.0} = 1 or {q70.0} = 2 or {q70.0} = 3',
    'q71.row1': '{q70.1} = 1 or {q70.1} = 2 or {q70.1} = 3',
    'q71.row2': '{q70.2} = 1 or {q70.2} = 2 or {q70.2} = 3',
    'q71.row3': '{q70.3} = 1 or {q70.3} = 2 or {q70.3} = 3',
    'q71.row4': '{q70.4} = 1 or {q70.4} = 2 or {q70.4} = 3',
    'q71.row5': '{q70.5} = 1 or {q70.5} = 2 or {q70.5} = 3',
    'q71.row6': '{q70.6} = 1 or {q70.6} = 2 or {q70.6} = 3',
    'q71.row7': '{q70.7} = 1 or {q70.7} = 2 or {q70.7} = 3',
    'q71.row8': '{q70.8} = 1 or {q70.8} = 2 or {q70.8} = 3',
    q72: J1adiffcult,
    'q72.row0': '{q70.0} = 1 or {q70.0} = 2 or {q70.0} = 3',
    'q72.row1': '{q70.1} = 1 or {q70.1} = 2 or {q70.1} = 3',
    'q72.row2': '{q70.2} = 1 or {q70.2} = 2 or {q70.2} = 3',
    'q72.row3': '{q70.3} = 1 or {q70.3} = 2 or {q70.3} = 3',
    'q72.row4': '{q70.4} = 1 or {q70.4} = 2 or {q70.4} = 3',
    'q72.row5': '{q70.5} = 1 or {q70.5} = 2 or {q70.5} = 3',
    'q72.row6': '{q70.6} = 1 or {q70.6} = 2 or {q70.6} = 3',
    'q72.row7': '{q70.7} = 1 or {q70.7} = 2 or {q70.7} = 3',
    'q72.row8': '{q70.8} = 1 or {q70.8} = 2 or {q70.8} = 3',
    q73: J1adiffcult,
    'q73.row0': '{q70.0} = 1 or {q70.0} = 2 or {q70.0} = 3',
    'q73.row1': '{q70.1} = 1 or {q70.1} = 2 or {q70.1} = 3',
    'q73.row2': '{q70.2} = 1 or {q70.2} = 2 or {q70.2} = 3',
    'q73.row3': '{q70.3} = 1 or {q70.3} = 2 or {q70.3} = 3',
    'q73.row4': '{q70.4} = 1 or {q70.4} = 2 or {q70.4} = 3',
    'q73.row5': '{q70.5} = 1 or {q70.5} = 2 or {q70.5} = 3',
    'q73.row6': '{q70.6} = 1 or {q70.6} = 2 or {q70.6} = 3',
    'q73.row7': '{q70.7} = 1 or {q70.7} = 2 or {q70.7} = 3',
    'q73.row8': '{q70.8} = 1 or {q70.8} = 2 or {q70.8} = 3',
    q74: '{q73.0} = 0',
    q75: '{q73.1} = 0',
    q76: '{q73.2} = 0',
    q77: '{q73.3} = 0',
    q78: '{q73.4} = 0',
    q79: '{q73.5} = 0',
    q80: '{q73.6} = 0',
    q81: '{q73.7} = 0',
    q82: '{q73.8} = 0',
    // J1-4a
    q83: '{q73.0} = 1 or {q73.1} = 1 or {q73.2} = 1 or {q73.3} = 1 or {q73.4} = 1 or {q73.5} = 1 or {q73.6} = 1 or {q73.7} = 1 or {q73.8} = 1',
    'q83.row0': '{q73.0} = 1',
    'q83.row1': '{q73.1} = 1',
    'q83.row2': '{q73.2} = 1',
    'q83.row3': '{q73.3} = 1',
    'q83.row4': '{q73.4} = 1',
    'q83.row5': '{q73.5} = 1',
    'q83.row6': '{q73.6} = 1',
    'q83.row7': '{q73.7} = 1',
    'q83.row8': '{q73.8} = 1',

    q84: J1adiffcult,
    'q84.row0': '{q70.0} = 1 or {q70.0} = 2 or {q70.0} = 3',
    'q84.row1': '{q70.1} = 1 or {q70.1} = 2 or {q70.1} = 3',
    'q84.row2': '{q70.2} = 1 or {q70.2} = 2 or {q70.2} = 3',
    'q84.row3': '{q70.3} = 1 or {q70.3} = 2 or {q70.3} = 3',
    'q84.row4': '{q70.4} = 1 or {q70.4} = 2 or {q70.4} = 3',
    'q84.row5': '{q70.5} = 1 or {q70.5} = 2 or {q70.5} = 3',
    'q84.row6': '{q70.6} = 1 or {q70.6} = 2 or {q70.6} = 3',
    'q84.row7': '{q70.7} = 1 or {q70.7} = 2 or {q70.7} = 3',
    'q84.row8': '{q70.8} = 1 or {q70.8} = 2 or {q70.8} = 3',
    q85: J1adiffcult,
    'q85.row0': '{q70.0} = 1 or {q70.0} = 2 or {q70.0} = 3',
    'q85.row1': '{q70.1} = 1 or {q70.1} = 2 or {q70.1} = 3',
    'q85.row2': '{q70.2} = 1 or {q70.2} = 2 or {q70.2} = 3',
    'q85.row3': '{q70.3} = 1 or {q70.3} = 2 or {q70.3} = 3',
    'q85.row4': '{q70.4} = 1 or {q70.4} = 2 or {q70.4} = 3',
    'q85.row5': '{q70.5} = 1 or {q70.5} = 2 or {q70.5} = 3',
    'q85.row6': '{q70.6} = 1 or {q70.6} = 2 or {q70.6} = 3',
    'q85.row7': '{q70.7} = 1 or {q70.7} = 2 or {q70.7} = 3',
    'q85.row8': '{q70.8} = 1 or {q70.8} = 2 or {q70.8} = 3',
    // J1-7a
    q86: J1adiffcult,
    'q86.row0': '{q70.0} = 1 or {q70.0} = 2 or {q70.0} = 3',
    'q86.row1': '{q70.1} = 1 or {q70.1} = 2 or {q70.1} = 3',
    'q86.row2': '{q70.2} = 1 or {q70.2} = 2 or {q70.2} = 3',
    'q86.row3': '{q70.3} = 1 or {q70.3} = 2 or {q70.3} = 3',
    'q86.row4': '{q70.4} = 1 or {q70.4} = 2 or {q70.4} = 3',
    'q86.row5': '{q70.5} = 1 or {q70.5} = 2 or {q70.5} = 3',
    'q86.row6': '{q70.6} = 1 or {q70.6} = 2 or {q70.6} = 3',
    'q86.row7': '{q70.7} = 1 or {q70.7} = 2 or {q70.7} = 3',
    'q86.row8': '{q70.8} = 1 or {q70.8} = 2 or {q70.8} = 3',
    q87: '{q86.0} = 0',
    q88: '{q86.1} = 0',
    q89: '{q86.2} = 0',
    q90: '{q86.3} = 0',
    q91: '{q86.4} = 0',
    q92: '{q86.5} = 0',
    q93: '{q86.6} = 0',
    q94: '{q86.7} = 0',
    q95: '{q86.8} = 0',

    q96: '{q86.0} = 1',
    q97: '{q86.1} = 1',
    q98: '{q86.2} = 1',
    q99: '{q86.3} = 1',
    q100: '{q86.4} = 1',
    q101: '{q86.5} = 1',
    q102: '{q86.6} = 1',
    q103: '{q86.7} = 1',
    q104: '{q86.8} = 1',
    // J1-8a
    q105: '{q86.0} = 1 or {q86.1} = 1 or {q86.2} = 1 or {q86.3} = 1 or {q86.4} = 1 or {q86.5} = 1 or {q86.6} = 1 or {q86.7} = 1 or {q86.8} = 1',
    'q105.row0': '{q86.0} = 1',
    'q105.row1': '{q86.1} = 1',
    'q105.row2': '{q86.2} = 1',
    'q105.row3': '{q86.3} = 1',
    'q105.row4': '{q86.4} = 1',
    'q105.row5': '{q86.5} = 1',
    'q105.row6': '{q86.6} = 1',
    'q105.row7': '{q86.7} = 1',
    'q105.row8': '{q86.8} = 1',

    // J1b
    q107: J1bdiffcult,
    'q107.row0': '{q106.0} = 1 or {q106.0} = 2 or {q106.0} = 3',
    'q107.row1': '{q106.1} = 1 or {q106.1} = 2 or {q106.1} = 3',
    'q107.row2': '{q106.2} = 1 or {q106.2} = 2 or {q106.2} = 3',
    'q107.row3': '{q106.3} = 1 or {q106.3} = 2 or {q106.3} = 3',
    'q107.row4': '{q106.4} = 1 or {q106.4} = 2 or {q106.4} = 3',
    'q107.row5': '{q106.5} = 1 or {q106.5} = 2 or {q106.5} = 3',
    'q107.row6': '{q106.6} = 1 or {q106.6} = 2 or {q106.6} = 3',
    'q107.row7': '{q106.7} = 1 or {q106.7} = 2 or {q106.7} = 3',
    q108: J1bdiffcult,
    'q108.row0': '{q106.0} = 1 or {q106.0} = 2 or {q106.0} = 3',
    'q108.row1': '{q106.1} = 1 or {q106.1} = 2 or {q106.1} = 3',
    'q108.row2': '{q106.2} = 1 or {q106.2} = 2 or {q106.2} = 3',
    'q108.row3': '{q106.3} = 1 or {q106.3} = 2 or {q106.3} = 3',
    'q108.row4': '{q106.4} = 1 or {q106.4} = 2 or {q106.4} = 3',
    'q108.row5': '{q106.5} = 1 or {q106.5} = 2 or {q106.5} = 3',
    'q108.row6': '{q106.6} = 1 or {q106.6} = 2 or {q106.6} = 3',
    'q108.row7': '{q106.7} = 1 or {q106.7} = 2 or {q106.7} = 3',
    q109: J1bdiffcult,
    'q109.row0': '{q106.0} = 1 or {q106.0} = 2 or {q106.0} = 3',
    'q109.row1': '{q106.1} = 1 or {q106.1} = 2 or {q106.1} = 3',
    'q109.row2': '{q106.2} = 1 or {q106.2} = 2 or {q106.2} = 3',
    'q109.row3': '{q106.3} = 1 or {q106.3} = 2 or {q106.3} = 3',
    'q109.row4': '{q106.4} = 1 or {q106.4} = 2 or {q106.4} = 3',
    'q109.row5': '{q106.5} = 1 or {q106.5} = 2 or {q106.5} = 3',
    'q109.row6': '{q106.6} = 1 or {q106.6} = 2 or {q106.6} = 3',
    'q109.row7': '{q106.7} = 1 or {q106.7} = 2 or {q106.7} = 3',
    q110: '{q109.0} = 0',
    q111: '{q109.1} = 0',
    q112: '{q109.2} = 0',
    q113: '{q109.3} = 0',
    q114: '{q109.4} = 0',
    q115: '{q109.5} = 0',
    q116: '{q109.6} = 0',
    q117: '{q109.7} = 0',
    // J1-4b
    q118: '{q109.0} = 1 or {q109.1} = 1 or {q109.2} = 1 or {q109.3} = 1 or {q109.4} = 1 or {q109.5} = 1 or {q109.6} = 1 or {q109.7} = 1',
    'q118.row0': '{q109.0} = 1',
    'q118.row1': '{q109.1} = 1',
    'q118.row2': '{q109.2} = 1',
    'q118.row3': '{q109.3} = 1',
    'q118.row4': '{q109.4} = 1',
    'q118.row5': '{q109.5} = 1',
    'q118.row6': '{q109.6} = 1',
    'q118.row7': '{q109.7} = 1',

    q119: J1bdiffcult,
    'q119.row0': '{q106.0} = 1 or {q106.0} = 2 or {q106.0} = 3',
    'q119.row1': '{q106.1} = 1 or {q106.1} = 2 or {q106.1} = 3',
    'q119.row2': '{q106.2} = 1 or {q106.2} = 2 or {q106.2} = 3',
    'q119.row3': '{q106.3} = 1 or {q106.3} = 2 or {q106.3} = 3',
    'q119.row4': '{q106.4} = 1 or {q106.4} = 2 or {q106.4} = 3',
    'q119.row5': '{q106.5} = 1 or {q106.5} = 2 or {q106.5} = 3',
    'q119.row6': '{q106.6} = 1 or {q106.6} = 2 or {q106.6} = 3',
    'q119.row7': '{q106.7} = 1 or {q106.7} = 2 or {q106.7} = 3',
    q120: J1bdiffcult,
    'q120.row0': '{q106.0} = 1 or {q106.0} = 2 or {q106.0} = 3',
    'q120.row1': '{q106.1} = 1 or {q106.1} = 2 or {q106.1} = 3',
    'q120.row2': '{q106.2} = 1 or {q106.2} = 2 or {q106.2} = 3',
    'q120.row3': '{q106.3} = 1 or {q106.3} = 2 or {q106.3} = 3',
    'q120.row4': '{q106.4} = 1 or {q106.4} = 2 or {q106.4} = 3',
    'q120.row5': '{q106.5} = 1 or {q106.5} = 2 or {q106.5} = 3',
    'q120.row6': '{q106.6} = 1 or {q106.6} = 2 or {q106.6} = 3',
    'q120.row7': '{q106.7} = 1 or {q106.7} = 2 or {q106.7} = 3',
    q121: J1bdiffcult,
    'q121.row0': '{q106.0} = 1 or {q106.0} = 2 or {q106.0} = 3',
    'q121.row1': '{q106.1} = 1 or {q106.1} = 2 or {q106.1} = 3',
    'q121.row2': '{q106.2} = 1 or {q106.2} = 2 or {q106.2} = 3',
    'q121.row3': '{q106.3} = 1 or {q106.3} = 2 or {q106.3} = 3',
    'q121.row4': '{q106.4} = 1 or {q106.4} = 2 or {q106.4} = 3',
    'q121.row5': '{q106.5} = 1 or {q106.5} = 2 or {q106.5} = 3',
    'q121.row6': '{q106.6} = 1 or {q106.6} = 2 or {q106.6} = 3',
    'q121.row7': '{q106.7} = 1 or {q106.7} = 2 or {q106.7} = 3',
    q122: '{q121.0} = 0',
    q123: '{q121.1} = 0',
    q124: '{q121.2} = 0',
    q125: '{q121.3} = 0',
    q126: '{q121.4} = 0',
    q127: '{q121.5} = 0',
    q128: '{q121.6} = 0',
    q129: '{q121.7} = 0',

    q130: '{q121.0} = 1',
    q131: '{q121.1} = 1',
    q132: '{q121.2} = 1',
    q133: '{q121.3} = 1',
    q134: '{q121.4} = 1',
    q135: '{q121.5} = 1',
    q136: '{q121.6} = 1',
    q137: '{q121.7} = 1',
    // J1-8b
    q138: '{q121.0} = 1 or {q121.1} = 1 or {q121.2} = 1 or {q121.3} = 1 or {q121.4} = 1 or {q121.5} = 1 or {q121.6} = 1 or {q121.7} = 1',
    'q138.row0': '{q121.0} = 1',
    'q138.row1': '{q121.1} = 1',
    'q138.row2': '{q121.2} = 1',
    'q138.row3': '{q121.3} = 1',
    'q138.row4': '{q121.4} = 1',
    'q138.row5': '{q121.5} = 1',
    'q138.row6': '{q121.6} = 1',
    'q138.row7': '{q121.7} = 1',

    // J1c
    // J1-5c
    q140: J1cdiffcult,
    'q140.row0': '{q139.0} = 1 or {q139.0} = 2 or {q139.0} = 3',
    'q140.row1': '{q139.1} = 1 or {q139.1} = 2 or {q139.1} = 3',
    'q140.row2': '{q139.2} = 1 or {q139.2} = 2 or {q139.2} = 3',
    'q140.row3': '{q139.3} = 1 or {q139.3} = 2 or {q139.3} = 3',
    'q140.row4': '{q139.4} = 1 or {q139.4} = 2 or {q139.4} = 3',
    'q140.row5': '{q139.5} = 1 or {q139.5} = 2 or {q139.5} = 3',
    'q140.row6': '{q139.6} = 1 or {q139.6} = 2 or {q139.6} = 3',
    q141: J1cdiffcult,
    'q141.row0': '{q139.0} = 1 or {q139.0} = 2 or {q139.0} = 3',
    'q141.row1': '{q139.1} = 1 or {q139.1} = 2 or {q139.1} = 3',
    'q141.row2': '{q139.2} = 1 or {q139.2} = 2 or {q139.2} = 3',
    'q141.row3': '{q139.3} = 1 or {q139.3} = 2 or {q139.3} = 3',
    'q141.row4': '{q139.4} = 1 or {q139.4} = 2 or {q139.4} = 3',
    'q141.row5': '{q139.5} = 1 or {q139.5} = 2 or {q139.5} = 3',
    'q141.row6': '{q139.6} = 1 or {q139.6} = 2 or {q139.6} = 3',
    // J1-7c
    q142: J1cdiffcult,
    'q142.row0': '{q139.0} = 1 or {q139.0} = 2 or {q139.0} = 3',
    'q142.row1': '{q139.1} = 1 or {q139.1} = 2 or {q139.1} = 3',
    'q142.row2': '{q139.2} = 1 or {q139.2} = 2 or {q139.2} = 3',
    'q142.row3': '{q139.3} = 1 or {q139.3} = 2 or {q139.3} = 3',
    'q142.row4': '{q139.4} = 1 or {q139.4} = 2 or {q139.4} = 3',
    'q142.row5': '{q139.5} = 1 or {q139.5} = 2 or {q139.5} = 3',
    'q142.row6': '{q139.6} = 1 or {q139.6} = 2 or {q139.6} = 3',
    q143: '{q142.0} = 0',
    q144: '{q142.1} = 0',
    q145: '{q142.2} = 0',
    q146: '{q142.3} = 0',
    q147: '{q142.4} = 0',
    q148: '{q142.5} = 0',
    q149: '{q142.6} = 0',

    q150: '{q142.0} = 1',
    q151: '{q142.1} = 1',
    q152: '{q142.2} = 1',
    q153: '{q142.3} = 1',
    q154: '{q142.4} = 1',
    q155: '{q142.5} = 1',
    q156: '{q142.6} = 1',
    q157: '{q142.0} = 1 or {q142.1} = 1 or {q142.2} = 1 or {q142.3} = 1 or {q142.4} = 1 or {q142.5} = 1 or {q142.6} = 1',
    'q157.row0': '{q142.0} = 1',
    'q157.row1': '{q142.1} = 1',
    'q157.row2': '{q142.2} = 1',
    'q157.row3': '{q142.3} = 1',
    'q157.row4': '{q142.4} = 1',
    'q157.row5': '{q142.5} = 1',
    'q157.row6': '{q142.6} = 1',

    // q158: '{q157.0} = 0 or {q157.0} = 1 or {q157.0} = 2 or {q157.0} = 3 or {q157.1} = 0 or {q157.1} = 1 or {q157.1} = 2 or {q157.1} = 3 or {q157.2} = 0 or {q157.2} = 1 or {q157.2} = 2 or {q157.2} = 3 or {q157.3} = 0 or {q157.3} = 1 or {q157.3} = 2 or {q157.3} = 3 or {q157.4} = 0 or {q157.4} = 1 or {q157.4} = 2 or {q157.4} = 3 or {q157.5} = 0 or {q157.5} = 1 or {q157.5} = 2 or {q157.5} = 3 or {q157.6} = 0 or {q157.6} = 1 or {q157.6} = 2 or {q157.6} = 3',

    q160: '{q159} = 1',
    q161: '{q159} = 1',
    q171: '{q170} = 1 or {q170} = 2',
    q172: '{q170} = 1 or {q170} = 2',
    q173: '{q1} = 100', // 隱藏
    q174: '{q170} = 1 or {q170} = 2',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = 0)`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    sfdSamplerId,
    sfdPId,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `<p>感謝您接受本次調查！</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (survey.getValue('q0') === 0) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
